import React from 'react';
import InfiniteScroll from 'components/shared/infiniteScroll/presentational/InfiniteScroll';
import { Payee } from 'lib/type';

interface ManagePayeesProps {
    data: Payee[];
    handleDelete: (payee: any) => void;
}

const ManagePayees = ({ data, handleDelete }: ManagePayeesProps) => {
    return (
        <div className="uk-payee-container">
            <InfiniteScroll className="uk-payee-list-container">
                {data.map(payee => {
                    return (
                        <div key={payee.id} className="uk-payee-item">
                            <div className="item-left">
                                <h1 className="uk-payee-name">
                                    {payee.payeeName}
                                </h1>
                                <div className="uk-payee-account">
                                    <p>{payee.accountNo}</p>
                                    <span>|</span>
                                    <p>{payee.sortCode}</p>
                                </div>
                            </div>
                            <button
                                className="delete-button"
                                onClick={() => handleDelete(payee)}
                            >
                                <i className="fas fa-trash-alt" />
                            </button>
                        </div>
                    );
                })}
            </InfiniteScroll>
        </div>
    );
};

export default ManagePayees;
